export default function (action: string, category: string, label: string, value?: any) {
  // @ts-ignore
  if (!window.heywhaleTrack || !action) {
    console.log('track cancelled: ', action, category, label, value)
    return;
  }
  // @ts-ignore
  window.heywhaleTrack.event(action, category, label, value);
}
